import "./rooms.css";

import React from "react";

import { BACKGROUNDS, ROOMS, ROUTES } from "../../data/content";
import { BedIcon, CoffeeIcon, ShowerIcon } from "../general/Icons";
import PageMeta from "../general/PageMeta";
import { LinkButton, PageBackground } from "../general/PageSections";
import Slideshow from "../general/Slideshow";

const Rooms = () => {
  return (
    <div className={"page-layout rooms"}>
      <PageMeta
        title={ROOMS.META_TITLE}
        description={ROOMS.DESCRIPTION}
      />
      <PageBackground src={BACKGROUNDS.ROOMS} />

      <div className={"container"}>
        <h1 className={"page-title"}>{ROOMS.TITLE}</h1>
        <section className={"content-box rooms-intro"}>
          {ROOMS.INTRO.map((text) => (
            <p key={text}>{text}</p>
          ))}
          <LinkButton path={ROUTES.BOOK}>Book Now</LinkButton>
        </section>
      </div>

      <ul className={"rooms-grid"}>
        {ROOMS.LIST.map((room) => (
          <li
            key={room.id}
            id={room.id}
            className={"room-card"}
          >
            <Slideshow
              photos={room.photos}
              label={`Photos of ${room.name}`}
              className={"room-card-photos"}
              showCounter
            />
            <div className={"room-card-details"}>
              <h2 className={"room-card-name"}>{room.name}</h2>
              <hr className={"rule"} />
              <ul className={"room-card-features"}>
                {room.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <div className={"room-card-icons"}>
                <ShowerIcon />
                <CoffeeIcon />
                <BedIcon />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Rooms;
